export default "__VITE_ASSET__B0G5A6OJ__"